export default __webpack_public_path__ + "cfbb48847eb8b72497ec3f43952d1f5a.svg";